import { useState, useEffect } from 'react'

// Reads the Atlas ADR / foreign catalog from /api/adr-universe — three buckets
// (us / home / preipo) + the distinct catalog-sector list for the US filter.
// Reference data; fetched once on mount. Powers the v3 Global Desk.
//
// Returns { us, home, preipo, sectors, counts, loading }.
export function useAdrUniverse() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    fetch('/api/adr-universe')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled) { setData(d); setLoading(false) } })
      .catch(() => { if (!cancelled) { setData(null); setLoading(false) } })
    return () => { cancelled = true }
  }, [])

  return {
    us: data?.us ?? [],
    home: data?.home ?? [],
    preipo: data?.preipo ?? [],
    sectors: data?.sectors ?? [],
    counts: data?.counts ?? { us: 0, home: 0, preipo: 0 },
    loading,
  }
}
